import '../../node_modules/bootstrap/dist/js/bootstrap.min';
import '../../js/remove-paragraph-from-headers.jsx';
import '../../components/navbar/navbar.jsx';
import '../../js/event-goal-push.jsx';
import './unhyped.scss';

// The sticky subscribe bar slides in once the hero has scrolled away.
try {
  const bar = document.getElementById('unhyped-bar');
  const hero = document.getElementById('unhyped-hero');

  if (bar && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      entries => bar.classList.toggle('is-visible', !entries[0].isIntersecting),
      { rootMargin: '-8px 0px 0px 0px', threshold: 0 }
    ).observe(hero);
  }
} catch (e) {
  console.log(e);
}

// Pillar cards play their background clip only while hovered.
try {
  document.querySelectorAll('.pillar').forEach(card => {
    const clip = card.querySelector('[data-hover-play]');

    if (!clip) return;

    card.addEventListener('pointerenter', () => {
      const played = clip.play();
      if (played && played.catch) played.catch(() => {});
    });
    card.addEventListener('pointerleave', () => clip.pause());
  });
} catch (e) {
  console.log(e);
}
